import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=3c760f70&scoped=true&"
import script from "./BasicTable.vue?vue&type=script&lang=js&"
export * from "./BasicTable.vue?vue&type=script&lang=js&"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=3c760f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c760f70",
  null
  
)

export default component.exports